var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100 text-center d-flex flex-column justify-content-center align-items-center my-auto"},[_c('div',{class:_vm.loaderStyleClass,attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]),(_vm.comment)?_c('div',[_vm._v(_vm._s(_vm.comment))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }